import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connecté");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-background border border-border px-4 py-3 text-sm text-white placeholder:text-muted-foreground focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent transition-colors";

  return (
    <div className="min-h-screen flex items-center justify-center px-6 grain relative">
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[30rem] h-[30rem] bg-accent/10 blur-3xl rounded-full pointer-events-none" />
      <div className="w-full max-w-md relative z-10">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-white mb-8 transition-colors">
          <ArrowLeft size={16} /> Retour au site
        </Link>
        <div className="bg-surface border border-border p-8">
          <div className="w-12 h-12 flex items-center justify-center border border-accent/40 bg-accent/5 text-accent mb-6">
            <Lock size={22} />
          </div>
          <h1 className="font-heading font-bold text-2xl mb-1">Espace admin</h1>
          <p className="text-muted-foreground text-sm mb-8">Consultez les demandes de contact.</p>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground block mb-2">Email</label>
              <input
                required
                type="email"
                data-testid="login-input-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@gmpdeveloppement.fr"
                className={inputCls}
              />
            </div>
            <div>
              <label className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground block mb-2">Mot de passe</label>
              <input
                required
                type="password"
                data-testid="login-input-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className={inputCls}
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full bg-accent text-black font-semibold px-6 py-3.5 flex items-center justify-center gap-2 hover:bg-accent-hover transition-colors disabled:opacity-60"
            >
              {loading && <Loader2 size={18} className="animate-spin" />}
              Se connecter
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
